<template>
  <div class="user-name edit-item" v-if="editingData">
    <div class="head"><b>氏名</b></div>
    <div class="data" v-if="!isOptionsMode">
      <input-text v-model="editingData.name" type="text" class="medium" :disabled="!isEditable"
        :error="getError(editingData, 'name')"></input-text>
      <p class="current-data" v-if="currentData?.name">{{ currentData.name }}</p>
    </div>

    <div class="data" v-else>
      <select-box v-if="allSyainOptions.length > 0" v-model="editingData.user_id" :options="allSyainOptions" class="medium" @update:modelValue="updateUserId"
        :error="getError(editingData, 'name')" :disabled="disabled"></select-box>
      <p v-else>読み込み中...</p>
      <p class="current-data" v-if="currentData?.name">{{ currentData.name }}</p>
    </div>

  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent, onMounted, ref } from 'vue';
import OptionConst from '@/const/Option';
import { useList } from '@/composable/syain/list/list';
import { DialogService } from '@/service/DialogService';
import { computed } from '@vue/reactivity';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    mode: {
      type: String,
      require: true
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup(props) {
    const { getError } = useForm();
    const { getAllSyain, allSyain, allSyainOptions, getAllSyainOptions } = useList()

    let isInit = ref(false)
    onMounted(async () => {
      if (!props.editingData) {
        return
      }

      if (isOptionsMode) {
        await getAllSyain()
        await getAllSyainOptions()
      }

      // 入社タイプ以外のページが、入社タイプ（user_id==null、氏名入力等）からの遷移された場合の処理
      // if (props.editingData && !props.editingData.user_id
      //   && (props.editingData.shinsei_type !== OptionConst.KOYOU_SHINSEI_TYPE.ENTRY
      //     && props.editingData.shinsei_type !== OptionConst.KOYOU_SHINSEI_TYPE.REPLACE_ENTRY)) {
      //   props.editingData.name = null;
      //   props.editingData.kana = null;
      //   props.editingData.nyuusya_date = null;
      //   props.editingData.staff_code = null;
      // }

      // 追加の場合で、現在のユーザがある場合はそれを使う
      if (props.editingData.shinsei_type == OptionConst.KOYOU_SHINSEI_TYPE.ADD && props.currentData != null) {
        updateUserId(props.currentData?.user_id as number);
      }
    })

    // 氏名（= val:user_id）が変更された場合の処理
    const updateUserId = async (selectedUserId: number) => {

      if (!props.editingData || !selectedUserId || !isInit) {
        return
      }

      const find = allSyain.value.find((syain) => { return syain.user_id === selectedUserId });
      if (!find) {
        DialogService.error({
          text: '処理に失敗しました（照合エラー）'
        })
        return
      }


      props.editingData.user_id = find.user_id;
      props.editingData.name = find.staff_name;
      props.editingData.staff_code = find.staff_code;
      props.editingData.kana = find.staff_kana;
      props.editingData.nyuusya_date = find.nyuusya_date;
    }

    // セレクトボックスから指名を選択するモード
    const isOptionsMode = computed(() => {
      if (!props.editingData) {
        return false
      }

      if (
        props.editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.REPLACE
      ) {
        return true
      }

      if (
        props.editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.ADD
      ) {
        return true
      }

      return false
    })

    // 変更可否
    const isEditable = computed(() => {
      if(props.disabled) {
        return false
      }

      if (
        props.editingData?.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.UPDATE ||
        props.editingData?.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.CHANGE ||
        props.editingData?.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.ADD
      ) {
        return false
      }
      return true
    })

    return {
      getError,
      OptionConst,
      updateUserId,
      isOptionsMode,
      isEditable,
      allSyainOptions
    }

  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';
</style>
